import { render, staticRenderFns } from "./Workjob.vue?vue&type=template&id=65b7a86d"
import script from "./Workjob.vue?vue&type=script&lang=js"
export * from "./Workjob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports